<template>
  <div class="table-content">
    <a-table
      :columns="columns"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <div slot="operation" class="operation" slot-scope="text, record">
        <p @click="view(record)">查看</p>
        <span v-if="record.status == 0">|</span>
        <a-popconfirm
          v-if="record.status == 0"
          title="确定要删除该申报吗?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="deleteDeclare(record)"
        >
          <p>删除</p>
        </a-popconfirm>
        <!-- <p v-if="record.status == 0" @click="deleteDeclare(record)">删除</p> -->
        <span>|</span>
        <p @click="downLoad(record)">下载</p>
      </div>

      <div slot="auditOperation" class="operation" slot-scope="text, record">
        <p @click="view(record)">查看</p>
        <span v-if="record.status != 5 && chooseType == 1">|</span>
        <!-- record.status == 1 && -->
        <p v-if="chooseType == 1" @click="returnDeclare(record)">退回</p>
        <span v-if="chooseType == 1">|</span>
        <p @click="downLoad(record)" v-if="chooseType == 1">下载</p>
      </div>
      <div slot="createAt" slot-scope="text">
        <p>{{ returnTimeStr(text) }}</p>
      </div>

      <div slot="cityOpinion" slot-scope="text">
        <p>{{ text == "" ? "未处理" : text }}</p>
      </div>
      <div slot="selfEvaluation" slot-scope="text">
        <p>{{ text ? text : "暂无" }}</p>
      </div>
      <div slot="projectName" slot-scope="text">
        <p>{{ text }}</p>
      </div>
      <div slot="status" slot-scope="text, record" class="status">
        <div v-if="userTypeValue == 'declarator'" class="status">
          <p>
            {{
              text == 0
                ? "草稿箱"
                : text == 1
                ? "已提交"
                : (record.status == 2 || record.status == 3) &&
                  record.toTarget == "declarator"
                ? "已退回"
                : "已提交"
            }}
          </p>
          <svg
            v-if="
              (record.status == 2 || record.status == 3) &&
              record.toTarget == 'declarator'
            "
            t="1677566418679"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2935"
            width="15"
            height="15"
            style="cursor: pointer"
            @click="viewReason(record)"
          >
            <path
              d="M512 1024c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512z m0-938.666667c-234.666667 0-426.666667 192-426.666667 426.666667s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667-192-426.666667-426.666667-426.666667z m0 512c-25.6 0-42.666667-17.066667-42.666667-42.666666v-298.666667c0-25.6 17.066667-42.666667 42.666667-42.666667s42.666667 17.066667 42.666667 42.666667v298.666667c0 21.333333-17.066667 42.666667-42.666667 42.666666z m0 81.066667c25.6 0 46.933333 21.333333 46.933333 46.933333s-21.333333 46.933333-46.933333 46.933334-46.933333-21.333333-46.933333-46.933334 21.333333-46.933333 46.933333-46.933333z"
              fill="#666666"
              p-id="2936"
            ></path>
          </svg>
        </div>
        <div v-if="userTypeValue == 'cityAdm'" class="status">
          <p>
            {{
              text == 0
                ? "草稿箱"
                : text == 1
                ? "已提交"
                : record.status == 3 && record.toTarget == "cityAdm"
                ? "已退回"
                : text == 4
                ? "已提交"
                : "已退回"
            }}
          </p>
          <svg
            v-if="record.status == 2 || record.status == 3"
            t="1677566418679"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2935"
            width="15"
            height="15"
            style="cursor: pointer"
            @click="viewReason(record)"
          >
            <path
              d="M512 1024c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512z m0-938.666667c-234.666667 0-426.666667 192-426.666667 426.666667s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667-192-426.666667-426.666667-426.666667z m0 512c-25.6 0-42.666667-17.066667-42.666667-42.666666v-298.666667c0-25.6 17.066667-42.666667 42.666667-42.666667s42.666667 17.066667 42.666667 42.666667v298.666667c0 21.333333-17.066667 42.666667-42.666667 42.666666z m0 81.066667c25.6 0 46.933333 21.333333 46.933333 46.933333s-21.333333 46.933333-46.933333 46.933334-46.933333-21.333333-46.933333-46.933334 21.333333-46.933333 46.933333-46.933333z"
              fill="#666666"
              p-id="2936"
            ></path>
          </svg>
        </div>
      </div>
    </a-table>
    <a-modal
      title="退回原因"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-textarea
        placeholder="请输入退回原因"
        v-model="rejectReason"
        :rows="4"
        style="resize: none"
      />
    </a-modal>
    <a-modal
      title="退回原因"
      :visible="viewVisible"
      @ok="viewVisible = false"
      @cancel="viewVisible = false"
    >
      <a-textarea
        placeholder="请输入退回原因"
        v-model="rejectReason"
        :rows="4"
        style="resize: none"
        readOnly
      />
    </a-modal>
  </div>
</template>

<script>
import {
  decInformationDeleteApi,
  decInformationinfoApi,
  decInformationDownloadApi,
  updateDecInformationApi,
  decInformationExpertEvaluationList,
  decInformationBackApi,
  decUserAccessInfoApi
} from "@/api/declare";
import moment from "moment-timezone";
export default {
  data() {
    return {
      userTypeValue: "",
      rejectReason: "",
      visible: false,
      viewVisible: false,
    };
  },
  props: {
    columns: {
      type: Array,
    },
    tableData: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    pagination: {
      type: Object,
    },
    chooseType: {
      type: Number,
    },
  },
  methods: {
    viewReason(val) {
      console.log(val);
      this.rejectReason = val.cityMessage;
      this.viewVisible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleOk() {
      let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
      let params = {
        id: declareInfoObj.id,
        message: this.rejectReason,
        toTarget: "declarator",
        fromSource: "cityAdm",
      };
      decInformationBackApi(params).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          setTimeout(() => {
            this.visible = false;
            this.$emit("backProject");
          }, 500);
        }
      });
    },
    // 退回
    returnDeclare(val) {
      sessionStorage.setItem("declareInfo", JSON.stringify(val));
      this.rejectReason = "";
      this.visible = true;
    },
    // 下载
    downLoad(val) {
      let params = {
        id: val.id,
      };
      decInformationDownloadApi(params.id).then((res) => {
        // console.log(res);
        if (res.status) {
          this.$message.success("下载成功");
          window.open(res.data);
          setTimeout(() => {
            this.$emit("backProject");
          }, 1000);
        } else {
          this.$message.error(res.message);
          setTimeout(() => {
            this.$emit("backProject");
          }, 1000);
        }
      });
    },
    // 删除
    deleteDeclare(val) {
      let params = {
        id: val.id,
      };
      decInformationDeleteApi(params.id).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          setTimeout(() => {
            this.$emit("backProject");
          }, 1000);
        } else {
          this.$message.error(res.message);
          setTimeout(() => {
            this.$emit("backProject");
          }, 1000);
        }
      });
    },
    view(val) {
      // 修改复位
      console.log(val);
      sessionStorage.setItem('expertEvaluationList',val.expertEvaluationList)
      sessionStorage.removeItem("revewInfo");
      sessionStorage.removeItem("myRateList");
      sessionStorage.removeItem("cityRateList");
      sessionStorage.removeItem("expertRateList");
      sessionStorage.removeItem("provincialRateList");
      if (this.userTypeValue == "expert") {
        // 获取专家评分及list
        // let userToken = sessionStorage.getItem('token')
        // console.log(userToken);
        // let params ={
        //   decId:val.checkRecordId
        // }
        // console.log(params);
        // decInformationExpertEvaluationList(params).then((res)=>{
        //   console.log(res);
        // })

        decUserAccessInfoApi(val.checkRecordId).then((res) => {
          console.log(res);
          if (res.status) {
            sessionStorage.setItem("declareInfo", JSON.stringify(res.data));
            setTimeout(() => {
              this.$emit("openTable",val.baseType);
            }, 1000);
          }
        });
      } else {
        decInformationinfoApi(val.id).then((res) => {
          if (res.status) {
            sessionStorage.setItem("declareInfo", JSON.stringify(res.data));
            setTimeout(() => {
                this.$emit("openTable",val.baseType);
            }, 1000);
          }
        });
      }
    },
    returnTimeStr(time) {
      return moment(time * 1000).format("YYYY-MM-DD");
    },
    handleTableChange(pagination) {
      console.log(pagination);
      this.$emit("pageChange", pagination);
    },
  },
  created() {
    if (localStorage.getItem("userModel")) {
      this.userTypeValue = JSON.parse(
        localStorage.getItem("userModel")
      ).userType;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
